// 中登网管理（与业务管理同级的一级菜单）
export default {
  title: '中登网管理',
  type: 'folder',
  name: Symbol('central-registry'),
  route: '/central-registry/config',
  inNav: true,
  icon: 'iconfont icon-pingzheng',
  isElementIcon: false,
  order: 5,
  permission: ['访问中登网管理'],
  children: [
    {
      title: '中登网对接配置',
      type: 'view',
      name: Symbol('central-registry-config'),
      route: '/central-registry/config',
      filePath: 'view/business/central-registry/config.vue',
      inNav: true,
      icon: 'iconfont icon-shezhi',
      isElementIcon: false,
      permission: ['访问中登网管理'],
    },
    {
      title: '凭证注册管理',
      type: 'view',
      name: Symbol('central-registry-register'),
      route: '/central-registry/register',
      filePath: 'view/business/central-registry/register-manage.vue',
      inNav: true,
      icon: 'iconfont icon-pingzheng',
      isElementIcon: false,
      permission: ['访问中登网管理'],
    },
    {
      title: '凭证登记记录',
      type: 'view',
      name: Symbol('central-registry-registration'),
      route: '/central-registry/registration',
      filePath: 'view/business/central-registry/registration-list.vue',
      inNav: true,
      icon: 'iconfont icon-rizhiguanli',
      isElementIcon: false,
      permission: ['访问中登网管理'],
    },
    {
      title: '中登网凭证查询',
      type: 'view',
      name: Symbol('central-registry-cert-query'),
      route: '/central-registry/cert-query',
      filePath: 'view/business/central-registry/cert-query.vue',
      inNav: true,
      icon: 'iconfont icon-chaxun',
      isElementIcon: false,
      permission: ['访问中登网管理'],
    },
    {
      title: '凭证状态同步',
      type: 'view',
      name: Symbol('central-registry-status-sync'),
      route: '/central-registry/status-sync',
      filePath: 'view/business/central-registry/status-sync.vue',
      inNav: true,
      icon: 'iconfont icon-tongbu',
      isElementIcon: false,
      permission: ['访问中登网管理'],
    },
  ],
}
